import { ExternalLink } from "lucide-react";
import { Reveal, Overline } from "@/components/site/Reveal";
import { FloatingDecor } from "@/components/site/FloatingDecor";
import { useLang } from "@/context/LanguageContext";

export const Timeline = () => {
  const { t } = useLang();
  const items = t("timeline.items");

  return (
    <section id="story" data-testid="timeline-section" className="relative bg-[#F8F9FA] py-24 md:py-32 overflow-hidden">
      <FloatingDecor />
      <div className="relative z-10 max-w-[1400px] mx-auto px-6 md:px-10">
        <Reveal>
          <div className="max-w-2xl">
            <Overline>{t("timeline.overline")}</Overline>
            <h2 className="mt-5 font-display text-4xl md:text-6xl tracking-tight text-[#0A1128] leading-[0.98]">{t("timeline.title")}</h2>
            <p className="mt-5 text-[#4B5563] md:text-lg leading-relaxed">{t("timeline.sub")}</p>
            <a
              data-testid="timeline-link"
              href="https://www.focushaitianmusic.org/our_school"
              target="_blank"
              rel="noopener noreferrer"
              className="mt-6 inline-flex items-center gap-2 text-[#B8901F] hover:text-[#D4AF37] transition-colors font-medium"
            >
              {t("timeline.link")} <ExternalLink size={16} />
            </a>
          </div>
        </Reveal>

        <div className="mt-14 flex gap-6 overflow-x-auto pb-6 snap-x snap-mandatory -mx-6 px-6 md:mx-0 md:px-0"
             style={{ scrollbarWidth: "thin" }} data-testid="timeline-scroller">
          {items.map((it, i) => (
            <Reveal key={i} delay={i * 0.08} className="snap-start shrink-0 w-[300px] md:w-[360px]">
              <div className="h-full bg-white border border-[#0A1128]/10 p-8 hover:border-[#D4AF37]/60 transition-colors duration-300 shadow-sm">
                <span className="font-display text-[#B8901F] text-2xl md:text-3xl">{it.year}</span>
                <div className="mt-4 mb-5 h-px bg-gradient-to-r from-[#D4AF37]/60 to-transparent" />
                <h3 className="font-display text-xl md:text-2xl text-[#0A1128] leading-snug">{it.title}</h3>
                <p className="mt-4 text-sm md:text-base text-[#4B5563] leading-relaxed">{it.body}</p>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
};
